"use strict";

( function( namespace ) {
	namespace.site_config = {
		sites: {
			"2068": {
				"site": "WVTM.com",
				"domain_id": "7337",
				"ga_id": {
					"prod": "UA-40776361-2",
					"stage": "UA-78842740-24",
					"qa": "UA-76972567-25",
				},
				"babator_key": "01a83116-2e50-11e6-90fb-d3269e16b2ed",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
			"2078": {
				"site": "WJCL.com",
				"domain_id": "7320",
				"ga_id": {
					"prod": "UA-61757935-1",
					"stage": "UA-78842740-1",
					"qa": "UA-76972567-2",
				},
				"babator_key": "01a8310e-2e50-11e6-90fb-d3269e16b2ed",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
			"2115": {
				"site": "KHTVnews.com",
				"domain_id": "7418",
				"ga_id": {
					"prod": "UA-38125940-1",
					"stage": "UA-78842740-28",
					"qa": "UA-76972567-28",
				},
				"babator_key": "",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
			"2118": {
				"site": "Vuz",
				"domain_id": "7432",
				"ga_id": {
					"prod": "UA-98423322-1",
					"stage": "UA-78842740-29",
					"qa": "UA-76972567-29",
				},
				"babator_key": "",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
			"10017": {
				"site": "The Boston Channel",
				"domain_id": "7275",
				"ga_id": {
					"prod": "UA-17912729-1",
					"stage": "UA-78842740-13",
					"qa": "UA-76972567-15",
				},
				"babator_key": "34e91060-d0dc-11e5-8fe6-19263f12cd2a",
				"facebook_ae_ids": {
					"desktop": "172044439981235_180551379130541",
					"mobile": "172044439981235_180551459130533",
				},
			},
			"10018": {
				"site": "WMUR.com",
				"domain_id": "7295",
				"ga_id": {
					"prod": "UA-17912649-1",
					"stage": "UA-78842740-21",
					"qa": "UA-76972567-22",
				},
				"babator_key": "01a83112-2e50-11e6-90fb-d3269e16b2ed",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
			"10019": {
				"site": "MoreTV32.com",
				"domain_id": "7306",
				"ga_id": {
					"prod": "UA-17913529-1",
					"stage": "UA-78842740-27",
					"qa": "UA-76972567-27",
				},
				"babator_key": "",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
			"10020": {
				"site": "WESH.com",
				"domain_id": "7284",
				"ga_id": {
					"prod": "UA-17912732-1",
					"stage": "UA-78842740-15",
					"qa": "UA-76972567-17",
				},
				"babator_key": "01a8310b-2e50-11e6-90fb-d3269e16b2ed",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
			"10021": {
				"site": "CW18TV.com",
				"domain_id": "7207",
				"ga_id": {
					"prod": "",
					"stage": "",
					"qa": "",
				},
				"babator_key": "",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
			"10022": {
				"site": "The Pittsburgh Channel",
				"domain_id": "7319",
				"ga_id": {
					"prod": "UA-17913128-1",
					"stage": "UA-78842740-23",
					"qa": "UA-76972567-24",
				},
				"babator_key": "01a83115-2e50-11e6-90fb-d3269e16b2ed",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
			"10023": {
				"site": "WBALtv.com",
				"domain_id": "7296",
				"ga_id": {
					"prod": "UA-17913511-1",
					"stage": "UA-78842740-12",
					"qa": "UA-76972567-14",
				},
				"babator_key": "01a83108-2e50-11e6-90fb-d3269e16b2ed",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
			"10024": {
				"site": "WBAL.com",
				"domain_id": "7212",
				"ga_id": {
					"prod": "",
					"stage": "",
					"qa": "",
				},
				"babator_key": "",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
			"10026": {
				"site": "WYFF4.com",
				"domain_id": "7325",
				"ga_id": {
					"prod": "UA-17912387-1",
					"stage": "UA-78842740-26",
					"qa": "UA-76972567-26",
				},
				"babator_key": "01a83118-2e50-11e6-90fb-d3269e16b2ed",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
			"10027": {
				"site": "WPBF.com",
				"domain_id": "7321",
				"ga_id": {
					"prod": "UA-17912562-1",
					"stage": "UA-78842740-3",
					"qa": "UA-76972567-3",
				},
				"babator_key": "01a83113-2e50-11e6-90fb-d3269e16b2ed",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
			"10028": {
				"site": "WGAL.com",
				"domain_id": "7322",
				"ga_id": {
					"prod": "UA-17912733-1",
					"stage": "UA-78842740-16",
					"qa": "UA-76972567-18",
				},
				"babator_key": "01a8310c-2e50-11e6-90fb-d3269e16b2ed",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
			"10029": {
				"site": "WXII12.com",
				"domain_id": "7279",
				"ga_id": {
					"prod": "UA-17913526-1",
					"stage": "UA-78842740-25",
					"qa": "UA-76972567-5",
				},
				"babator_key": "01a83117-2e50-11e6-90fb-d3269e16b2ed",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
			"10030": {
				"site": "WLKY.com",
				"domain_id": "7299",
				"ga_id": {
					"prod": "UA-17912831-1",
					"stage": "UA-78842740-18",
					"qa": "UA-76972567-20",
				},
				"babator_key": "01a8310f-2e50-11e6-90fb-d3269e16b2ed",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
			"10031": {
				"site": "WMTW.com",
				"domain_id": "7311",
				"ga_id": {
					"prod": "UA-17912737-1",
					"stage": "UA-78842740-20",
					"qa": "UA-76972567-6",
				},
				"babator_key": "01a83111-2e50-11e6-90fb-d3269e16b2ed",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
			"10032": {
				"site": "WPTZ.com",
				"domain_id": "7332",
				"ga_id": {
					"prod": "UA-17913127-1",
					"stage": "UA-78842740-22",
					"qa": "UA-76972567-23",
				},
				"babator_key": "01a83114-2e50-11e6-90fb-d3269e16b2ed",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
			"10033": {
				"site": "KMBC.com",
				"domain_id": "7210",
				"ga_id": {
					"prod": "UA-17912642-1",
					"stage": "UA-78842740-8",
					"qa": "UA-76972567-11",
				},
				"babator_key": "01a83103-2e50-11e6-90fb-d3269e16b2ed",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
			"10034": {
				"site": "WISN.com",
				"domain_id": "7300",
				"ga_id": {
					"prod": "UA-17912827-1",
					"stage": "UA-78842740-17",
					"qa": "UA-76972567-19",
				},
				"babator_key": "01a8310d-2e50-11e6-90fb-d3269e16b2ed",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
			"10035": {
				"site": "WLWT.com",
				"domain_id": "7290",
				"ga_id": {
					"prod": "UA-17912928-1",
					"stage": "UA-78842740-19",
					"qa": "UA-76972567-21",
				},
				"babator_key": "01a83110-2e50-11e6-90fb-d3269e16b2ed",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
			"10036": {
				"site": "WDSU.com",
				"domain_id": "7302",
				"ga_id": {
					"prod": "UA-17912456-1",
					"stage": "UA-78842740-14",
					"qa": "UA-76972567-16",
				},
				"babator_key": "01a8310a-2e50-11e6-90fb-d3269e16b2ed",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
			"10037": {
				"site": "KOCO.com",
				"domain_id": "7293",
				"ga_id": {
					"prod": "UA-17913508-1",
					"stage": "UA-78842740-10",
					"qa": "UA-76972567-13",
				},
				"babator_key": "01a83105-2e50-11e6-90fb-d3269e16b2ed",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
			"10038": {
				"site": "KCCI.com",
				"domain_id": "7209",
				"ga_id": {
					"prod": "UA-17911099-1",
					"stage": "UA-78842740-4",
					"qa": "UA-76972567-7",
				},
				"babator_key": "",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
			"10039": {
				"site": "KETV.com",
				"domain_id": "7317",
				"ga_id": {
					"prod": "UA-17912548-1",
					"stage": "UA-78842740-6",
					"qa": "UA-76972567-9",
				},
				"babator_key": "01a83101-2e50-11e6-90fb-d3269e16b2ed",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
			"10040": {
				"site": "WAPT.com",
				"domain_id": "7219",
				"ga_id": {
					"prod": "UA-17913510-1",
					"stage": "UA-78842740-11",
					"qa": "UA-76972567-4",
				},
				"babator_key": "01a83107-2e50-11e6-90fb-d3269e16b2ed",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
			"10041": {
				"site": "4029TV.com",
				"domain_id": "7283",
				"ga_id": {
					"prod": "UA-17912725-1",
					"stage": "UA-78842740-7",
					"qa": "UA-76972567-10",
				},
				"babator_key": "01a83102-2e50-11e6-90fb-d3269e16b2ed",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
			"10042": {
				"site": "KCRA.com",
				"domain_id": "7323",
				"ga_id": {
					"prod": "UA-17913106-1",
					"stage": "UA-78842740-5",
					"qa": "UA-76972567-8",
				},
				"babator_key": "01a83100-2e50-11e6-90fb-d3269e16b2ed",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
			"10043": {
				"site": "My58.com",
				"domain_id": "7305",
				"ga_id": {
					"prod": "",
					"stage": "",
					"qa": "",
				},
				"babator_key": "",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
			"10044": {
				"site": "KOAT.com",
				"domain_id": "7277",
				"ga_id": {
					"prod": "UA-17912551-1",
					"stage": "UA-78842740-9",
					"qa": "UA-76972567-12",
				},
				"babator_key": "01a83104-2e50-11e6-90fb-d3269e16b2ed",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
			"10045": {
				"site": "KITV.com",
				"domain_id": "7312",
				"ga_id": {
					"prod": "",
					"stage": "",
					"qa": "",
				},
				"babator_key": "",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
			"10046": {
				"site": "KSBW.com",
				"domain_id": "7292",
				"ga_id": {
					"prod": "UA-17912728-1",
					"stage": "UA-78842740-2",
					"qa": "UA-76972567-1",
				},
				"babator_key": "01a83106-2e50-11e6-90fb-d3269e16b2ed",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
			"2138": {
				"site": "WATCHSTITCH.com",
				"domain_id": "7509",
				"ga_id": {
					"prod": "UA-110814170-1",
					"stage": "UA-78842740-29",
					"qa": "UA-76972567-29",
				},
				"babator_key": "",
				"facebook_ae_ids": {
					"desktop": "",
					"mobile": "",
				},
			},
		},

		ga_group_ids: {
			"prod": {
				"HTV": "UA-17916775-1",
			},
			"stage": {
				"HTV": "UA-79018554-1",
			},
			"qa": {
				"HTV": "UA-79018554-2",
			},
		},

		fb_manager_ids: {
			"HTV": "10152697860355891",
		},

		set_site_data: function( id, url, hash, bu ) {
			var env = "prod";

			url = url || "";

			/*eslint-disable*/
			if ( url.match(/\/\/.*(qa\.){1}[^\/]+/i) || url.match(/\/\/.*(stitch-dev\.){1}[^\/]+/i) ) {
				env = "qa";
			}
			if ( url.match(/\/\/.*(stage\.){1}[^\/]+/i) ) {
				env = "stage";
			}
			/* eslint-enable*/

			var site_data = {
				site_id: "2108",
				domain_id: "7392",
				ga_id: "",
				ga_group_id: "",
				bu: "",
				babator_key: "",
				facebook_ae_ids: {
					"desktop": "",
					"mobile": "",
				},
				fb_manager_id: "",
				hash: hash || "",
			};

			if ( this.sites[ id ] ) {
				site_data.site_id = "" + id;
				site_data.domain_id = this.sites[ id ].domain_id;
				site_data.site = this.sites[ id ].site;
				site_data.ga_id = this.sites[ id ].ga_id[ env ];
				site_data.ga_group_id = ( bu && this.ga_group_ids[ env ][ bu ] ) ? this.ga_group_ids[ env ][ bu ] : "";
				site_data.bu = ( bu ) ? bu : "";
				site_data.babator_key = this.sites[ id ].babator_key;
				site_data.facebook_ae_ids = this.sites[ id ].facebook_ae_ids;
				site_data.fb_manager_id = ( bu && this.fb_manager_ids[ bu ] ) ? this.fb_manager_ids[ bu ] : "";
			}

			return site_data;
		},
	};
} )( window.hearstLumierePlayer = window.hearstLumierePlayer || /* istanbul ignore next */ {} );



//////////////////
// WEBPACK FOOTER
// ./src/siteconfig.js
// module id = 93
// module chunks = 0